/*eslint-disable no-undef */
/*eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Container, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import ResultCard from './ResultCard';
import SearchFilter from './SearchFilter';
import './index.scss';
import InLineSearchFilter from './InLineSearchFilter';
import CostBar from '../../components/cost-bar/CostBar';
import SearchResultsCard from '../../skeleton/SearchResultsCard';
import CustomPagination from '../../../common/pagination';
import CustomPaginationItemsDisplay from '../../../common/pagination/CustomPaginationItemsDisplay';
import {
  setFilterChangeStatus,
  setSearchProviderParams,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from 'src/redux/admin/priceCompareSlice';
import DataNotFound from '../../../common/dataNotFound/DataNotFound';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import BottomSideBar from '../../components/bottom-sidebar/BottomSideBar';
import { LocalConvenienceStoreOutlined } from '@material-ui/icons';
import {
  getPriceComaperFilters,
  searchProviders,
} from '../../../../../redux/admin/api-calls/priceCompare';
import { ToastContainer } from 'react-toastify';

const displayPaginationMininumCount = 10;
//const NumberOfItemsSelect = ({
//pagination,
//pageSizeHandler,
//isSuffixMessageVisible,
//dataLength,
//}) => (
//<>
//{pagination?.TotalRecords > displayPaginationMininumCount ? (
//<CustomPaginationItemsDisplay
//pageSize={pagination?.PageSize}
//setPageSize={pageSizeHandler}
//prefixMessage="Records per page"
//suffixMessage={
//isSuffixMessageVisible &&
//`Showing ${
//pagination?.PageSize * (pagination?.PageNumber - 1) + 1
//} - ${
//pagination?.PageSize * (pagination?.PageNumber - 1) + dataLength
//} of ${pagination?.TotalRecords} provider results`
//}
///>
//) : null}
//</>
//);

const SearchResults = ({
  data,
  pagination,
  isSearchingProviders,
  serachNetworksFor,
  CoveredCostComparePriceArray,
}) => {
  const [currentPage, setCurrentPage] = useState(pagination?.PageNumber);
  const [pageSize, setPageSize] = useState(pagination?.PageSize);
  const [searchGenderFilterClicked, setSearchGenderFilterClicked] =
    useState('');
  const [searchDistanceFilterClicked, setSearchDistanceFilterClicked] =
    useState('');
  const [searchLanguageFilterClicked, setSearchLanguageFilterClicked] =
    useState('');
  const [searchFilterBestMatchClicked, setSearchBestMatchFilterClicked] =
    useState('');
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );

  const { Provider } = allFilters;
  const {
    showFilterBar,
    noResultsFound,
    showServerError,
    address,
    providerType,
    selectedCheckedItems,
    selectedCheckedRowData,
    searchProviderFiltersChanged,
  } = useSelector(({ priceCompareAdmin }) => priceCompareAdmin);
  const { DoctorByType, DoctorByName, facilityname, speciality } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams,
  );
  const [searchTerm, setSearchTerm] = useState('');
  const { providerByData, typesOfSpecialtyData } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchParamsForUI,
  );

  const getSearchTearm = () => {
    let searchText = `${address}/`;

    if (typesOfSpecialtyData) {
      if (Provider === 'facility') {
        if (providerByData === 'facility-type') {
          searchText +=
            'Facility Type/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        } else {
          searchText +=
            'Facility Name or Tax ID/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        }
      } else {
        if (providerByData === 'doctor-type') {
          searchText +=
            'Doctor Type/' + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        } else {
          searchText +=
            "Doctor's Name or NPI/" + typesOfSpecialtyData.value
              ? typesOfSpecialtyData.value
              : '';
        }
      }
    }
    setSearchTerm(searchText);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    getSearchTearm();
  }, [DoctorByType, DoctorByName, speciality, facilityname, address]);

  useEffect(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    //setCurrentTableData(data.slice(firstPageIndex, lastPageIndex));
  }, [currentPage, pageSize]);

  const pageSizeHandler = (pageSizeInfo) => {
    setPageSize(1);
    dispatch(setSearchProviderParams({ pagenumber: 1 }));
    dispatch(setSearchProviderParams({ pagesize: pageSizeInfo.value }));
    dispatch(setFilterChangeStatus(true));
  };

  const pageChangeHandler = (pageNum) => {
    dispatch(setSearchProviderParams({ pagenumber: pageNum }));
    dispatch(setFilterChangeStatus(true));
  };
  const onChangeGenderEvent = (val) => {
    setSearchGenderFilterClicked(val);
  };
  const onChangeDistanceEvent = (val) => {
    setSearchDistanceFilterClicked(val);
  };
  const onChangeLanguageEvent = (val) => {
    setSearchLanguageFilterClicked(val);
  };
  const onChangeBestMatchEvent = (val) => {
    setSearchBestMatchFilterClicked(val);
  };
  useEffect(() => {
    if (searchProviderFiltersChanged === true) {
      dispatch(setFilterChangeStatus(false));
      dispatch(searchProviders());
      dispatch(getPriceComaperFilters());
    }
  }, [searchProviderFiltersChanged]);

  return (
    <>
      <div>
        <SearchFilter />
      </div>
      {/*In line filter */}
      {showFilterBar && (
        <div className="provider-search-filter-container mt-4 mt-md-5 mb-0">
          <Container role="In line search">
            <InLineSearchFilter
              onChangeGenderEvent={(val) => onChangeGenderEvent(val)}
              onChangeDistanceEvent={(val) => onChangeDistanceEvent(val)}
              onChangeLanguageEvent={(val) => onChangeLanguageEvent(val)}
              onChangeBestMatchEvent={(val) => onChangeBestMatchEvent(val)}
            />
          </Container>
        </div>
      )}

      {/*cost bar */}
      {/*<div role="cost bar" className="cost-bar">
        <CostBar />
      </div> */}
      <div
        className="price-compare-results-admin-container"
        role="table"
        aria-label="Compare Price Results"
        aria-describedby="search_results_price_compare"
      >
        {!isSearchingProviders && data && data.length > 0 && (
          <>
            <div id="search_results_price_compare" className="sr-only">
              Compare Price for Provider Results
            </div>
            {pagination && (
              <Row className="my-4 container-offset">
                <Col md={7} className="display-pagination">
                  {/*<NumberOfItemsSelect
                    pagination={pagination}
                    dataLength={data?.length || 0}
                    pageSizeHandler={pageSizeHandler}
                    isSuffixMessageVisible
                  /> */}
                </Col>
                {pagination?.TotalRecords > displayPaginationMininumCount ? (
                  <Col md={5} className="display-pagination">
                    <CustomPagination
                      className="pagination-bar justify-content-end find-doctor-pagination"
                      currentPage={pagination?.PageNumber}
                      totalCount={pagination?.TotalRecords}
                      siblingCount={1}
                      pageSize={pagination?.PageSize}
                      onPageChange={(page) => {
                        pageChangeHandler(page);
                      }}
                    />
                  </Col>
                ) : null}
              </Row>
            )}

            {data &&
              data.map((ele, i) => {
                return (
                  <Fragment key={i}>
                    <ResultCard
                      elemkey={`${ele.PhysicianID}${i}`}
                      data={ele}
                      isAccordion={true}
                      setSelectedCheckedItems={setSelectedCheckedItems}
                      selectedCheckedItems={selectedCheckedItems}
                      setSelectedCheckedRowData={setSelectedCheckedRowData}
                      selectedCheckedRowData={selectedCheckedRowData}
                      serachNetworksFor={serachNetworksFor}
                      CoveredCostComparePriceArray={
                        CoveredCostComparePriceArray
                      }
                    />
                  </Fragment>
                );
              })}

            {pagination && (
              <Row className="my-4 container-offset">
                <Col md={7}>
                  {/*<NumberOfItemsSelect
                    pagination={pagination}
                    dataLength={data?.length || 0}
                    pageSizeHandler={pageSizeHandler}
                    isSuffixMessageVisible
                  /> */}
                </Col>
                {pagination?.TotalRecords > displayPaginationMininumCount ? (
                  <Col md={5}>
                    <CustomPagination
                      className="pagination-bar justify-content-end"
                      currentPage={pagination?.PageNumber}
                      totalCount={pagination?.TotalRecords}
                      siblingCount={1}
                      pageSize={pagination?.PageSize}
                      onPageChange={(page) => {
                        pageChangeHandler(page);
                      }}
                    />
                  </Col>
                ) : null}
              </Row>
            )}
          </>
        )}

        {isSearchingProviders && (
          <div className="mt-5 container-offset">
            {[0, 1, 2].map((ele, i) => {
              return (
                <Fragment key={i}>
                  <SearchResultsCard />
                </Fragment>
              );
            })}
          </div>
        )}

        {(noResultsFound || (!isSearchingProviders && data?.length === 0)) && (
          <div className="container-offset">
            <DataNotFound searchText={searchTerm} />
          </div>
        )}
      </div>
      <div>
        {showServerError && (
          <CustomClientError
            ErrorHeading="Something went wrong with the request!"
            ErrorMessage="Please try again."
            CustomClasses="p-0 m-0"
          />
        )}
      </div>
      <BottomSideBar
        selectedCheckedItems={selectedCheckedItems}
        selectedCheckedRowData={selectedCheckedRowData}
      ></BottomSideBar>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
};

export default SearchResults;
